import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);   // null = loading, false = logged out, obj = logged in
  const [fleet, setFleet] = useState(null);

  const loadFleet = async () => {
    try {
      const { data } = await api.get("/fleet");
      setFleet(data);
      return data;
    } catch { return null; }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const handoff = params.get("_t");
    if (handoff) {
      localStorage.setItem("ironlog_token", handoff);
      params.delete("_t");
      const q = params.toString();
      window.history.replaceState({}, "", window.location.pathname + (q ? `?${q}` : ""));
    }
    const token = localStorage.getItem("ironlog_token");
    if (!token) { setUser(false); return; }
    api.get("/auth/me")
      .then(({ data }) => { setUser(data); loadFleet(); })
      .catch(() => { localStorage.removeItem("ironlog_token"); setUser(false); });
  }, []);

  const handleAuth = async (path, payload) => {
    try {
      const { data } = await api.post(`/auth/${path}`, payload);
      localStorage.setItem("ironlog_token", data.token);
      setUser(data.user);
      await loadFleet();
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
    }
  };

  const login = (email, password) => handleAuth("login", { email, password });
  const register = (payload) => handleAuth("register", payload);
  const logout = () => {
    localStorage.removeItem("ironlog_token");
    setUser(false); setFleet(null);
  };

  return (
    <AuthContext.Provider value={{ user, fleet, setFleet, loadFleet, login, register, logout, isManager: user?.role === "manager", isAdmin: user?.is_admin, isFree: fleet?.plan === "free" }}>
      {children}
    </AuthContext.Provider>
  );
}
